import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListPaymentRequests extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/payment-requests/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Amount',
        dataIndex: 'amount'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Due Date',
        dataIndex: 'due_date'
      }
    ]
  }

  getData = () => {
    const { paymentRequests } = this.props

    const data = paymentRequests.map((paymentRequest, index) => {
      // format date from db
      paymentRequest.due_date = moment(new Date(paymentRequest.due_date)).format('YYYY-MM-DD')
      const returnObj = Object.assign(
        {
          key: `${paymentRequest.id}${index}`,
          job: {
            job_id: paymentRequest.job_id,
            job_type: paymentRequest.job_type,
            id: paymentRequest.id
          }
        },
        paymentRequest
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div style={{ marginTop: 20 }}>
        <h6>Payment Requests</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListPaymentRequests



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListPaymentRequests.js